import cleanUpResponse from "@/util/cleanUpResponse";

export default async function GetAllLUOrderLineItems() {
  const response = await $.soap({
    body: {
      GetAllLUOrderLineItems: {
        $xmlns: 'http://dla.mil/ems/db/lookup/lu_order_line_item'
      }
    },
    blueprintArrays: ['GetAllLUOrderLineItemsResponse'],
    blueprint: {
      allLineItems: [
        '$..tuple',
        {
          id: '$..ID',
          formTypeId: '$..FormTypeID',
          imgUrl: '$..ImgUrl',
          clin: '$..CLIN',
          price: '$..Price',
          volumeBand: '$..VolumeBand',
          model: '$..Model',
          laserPrinterTonerCartridgeType: '$..LaserPrinterTonerCartridgeType',
          description: '$..Description',
          paperCapacityHandling: '$..PaperCapacityHandling',
          configurationAndPricing: '$..ConfigurationAndPricing',
          serviceAcronym: '$..ServiceAcronym',
          speedPPM: '$..SpeedPPM',
          isColor: '$..IsColor',
          isNIPR: '$..IsNIPR',
          monthlyVolume: '$..MonthlyVolume',
          estimatedMonthlyVolumeMono: '$..EstimatedMonthlyVolumeMono',
          estimatedMonthlyVolumeColor: '$..EstimatedMonthlyVolumeColor',
          deliveryTypeId: '$..DeliveryTypeID',
          chargesFrequencyId: '$..ChargesFrequencyID',
          panel: '$..Panel'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.allLineItems;
}